export const AGREEMENTS_CONFIG = 'agreements'

export const agreements: Record<string, string> = {
  allow_marketing: 'emailOffers',
  allow_direct_marketing: 'directMarketing',
  allow_partners_marketing: 'partnersOffers',
  allow_sms_marketing: 'smsOffers'
}
